import { styled } from '@mui/material';
import type { FormItemUiDefinition } from 'types/formItem';

export const RootWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '16px',
  width: '100%',
}));

export const InputWrapper = styled('div')<{
  formItemUiDefinition?: FormItemUiDefinition;
  error?: boolean;
  lightError?: boolean;
}>(({ theme, formItemUiDefinition, error, lightError }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '16px',
  borderRadius: '16px',
  backgroundColor:
    error && !lightError
      ? theme.palette.error.light
      : formItemUiDefinition?.attributeColor
        ? formItemUiDefinition?.attributeColor
        : theme.palette.secondary.light,
  width: '100%',
  minHeight: '200px',
  boxSizing: 'border-box',
  overflow: 'hidden',
  border: `1px solid ${error || lightError ? theme.palette.error.main : formItemUiDefinition?.columnBorderColor || 'transparent'}`,
}));

export const FilesWrapper = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  width: '100%',
  gap: '14px',
  containerType: 'inline-size',
}));

export const ButtonsWrapper = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '8px',
}));
